module.exports = __webpack_public_path__ + "img/liqlidv2.32cf7cf3.png";